import { Description, StepperContainer, StyledProgress } from './styles';

export type StepperType = {
	prefix?: string;
	suffix?: string;
	steps: number;
	passedSteps: number;
};

export const Stepper = ({ prefix, steps, suffix, passedSteps }: StepperType) => {
	const getProggressBar = () => {
		const percentage = (passedSteps / steps) * 100;
		if (percentage === 100) {
			return <StyledProgress percent={percentage} showInfo={false} status="success" steps={3} $finished />;
		}

		return <StyledProgress percent={percentage} showInfo={false} />;
	};

	const getMessage = () => {
		const msg = [`${passedSteps}/${steps}`];

		if (prefix) {
			msg.unshift(prefix);
		}

		if (suffix) {
			msg.push(suffix);
		}

		return msg.join(' ');
	};

	return (
		<StepperContainer>
			{getProggressBar()}
			<Description>{getMessage()}</Description>
		</StepperContainer>
	);
};
